/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import moment from 'moment';
import 'moment/locale/ru';

moment.locale('ru');

export default function formatDate(date, dateFormat) {
  const normalCalendar = {
    lastDay: '[Вчера в] HH:mm',
    sameDay: '[Сегодня в] HH:mm',
    nextDay: '[Завтра в] HH:mm',
    lastWeek: '[В] dddd [в] HH:mm',
    nextWeek: 'dddd [at] HH:mm',
    sameElse: 'D MMM YYYY HH:mm',
  };
  const shortCalendar = {
    lastDay: '[Вчера в] HH:mm',
    sameDay: '[Сегодня в] HH:mm',
    lastWeek: 'D MMMM',
    sameElse: 'D MMMM',
  };

  let outputDate = '';

  switch (dateFormat) {
    case 'short':
      outputDate = moment(date).calendar(null, shortCalendar);

      break;

    case 'normal':
      outputDate = moment(date).calendar(null, normalCalendar);
      break;

    case 'full':
      outputDate = moment(date).format('D MMMM YYYY HH:mm');
      break;

    case 'forNews':
      outputDate = moment(date).format('MMMM D, YYYY');
      break;

    default:
      outputDate = moment(date).format(dateFormat);
      break;
  }

  outputDate = outputDate.toString();
  outputDate = outputDate.charAt(0).toUpperCase() + outputDate.slice(1);

  return outputDate;
}
